function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "layers",
  transform: "translate(0.1 0.123)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M14.638,30.217.388,19.766a.95.95,0,0,1,0-1.532L4.525,15.2.388,12.166a.951.951,0,0,1,0-1.533L14.638.184a.953.953,0,0,1,1.125,0l14.25,10.45a.951.951,0,0,1,0,1.533L25.875,15.2l4.137,3.034a.95.95,0,0,1,0,1.532L15.763,30.217a.953.953,0,0,1-1.125,0Z",
  transform: "translate(0 0)",
  fill: "#ec6423",
  stroke: "#ec6423",
  strokeMiterlimit: 10,
  strokeWidth: 0.2
}));

function SvgProjects(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.6,
    height: 30.624,
    viewBox: "0 0 30.6 30.624",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.f664c112.svg";
export { ForwardRef as ReactComponent };